// extracted by mini-css-extract-plugin
export default {"root":"style_root__Xx9SD","navItem":"style_navItem__xQl34","navItemActive":"style_navItemActive__80S44","navItemName":"style_navItemName__7WG11"};